var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13476_21175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5013 4.99609C15.6213 4.99609 5.16797 15.4494 5.16797 28.3294C5.16797 41.2094 15.6213 51.6628 28.5013 51.6628C41.3813 51.6628 51.8346 41.2094 51.8346 28.3294C51.8346 15.4494 41.3813 4.99609 28.5013 4.99609ZM16.998 42.9828C18.0013 40.8828 24.1146 38.8294 28.5013 38.8294C32.888 38.8294 39.0246 40.8828 40.0046 42.9828C36.8313 45.5028 32.8413 46.9961 28.5013 46.9961C24.1613 46.9961 20.1713 45.5028 16.998 42.9828ZM43.3413 39.5994C40.0046 35.5394 31.908 34.1628 28.5013 34.1628C25.0946 34.1628 16.998 35.5394 13.6613 39.5994C11.2813 36.4728 9.83464 32.5761 9.83464 28.3294C9.83464 18.0394 18.2113 9.66276 28.5013 9.66276C38.7913 9.66276 47.168 18.0394 47.168 28.3294C47.168 32.5761 45.7213 36.4728 43.3413 39.5994ZM28.5013 14.3294C23.9746 14.3294 20.3346 17.9694 20.3346 22.4961C20.3346 27.0228 23.9746 30.6628 28.5013 30.6628C33.028 30.6628 36.668 27.0228 36.668 22.4961C36.668 17.9694 33.028 14.3294 28.5013 14.3294ZM28.5013 25.9961C26.5646 25.9961 25.0013 24.4328 25.0013 22.4961C25.0013 20.5594 26.5646 18.9961 28.5013 18.9961C30.438 18.9961 32.0013 20.5594 32.0013 22.4961C32.0013 24.4328 30.438 25.9961 28.5013 25.9961Z",
    fill: "#6366F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13476_21175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5 0.328125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircle);
export default __webpack_public_path__ + "static/media/account_circle.d7450c273929a0aa86fd67eff6043dab.svg";
export { ForwardRef as ReactComponent };